import { Navigate } from "react-router-dom";
import { ROUTES } from "../../lib/constants.js";
import { useUser } from "../UserContext.js";

export default function HostRoute({ children }) {
  const { isHost, runId } = useUser();

  if (isHost) {
    return children;
  }

  return <Navigate to={ROUTES.BASE.replace(":runId", runId)} replace />;
}
